export class WarmCapacity {
    'vcpu';
    'memory';
    'storage';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vcpu",
            "baseName": "vcpu",
            "type": "number",
            "format": ""
        },
        {
            "name": "memory",
            "baseName": "memory",
            "type": "number",
            "format": ""
        },
        {
            "name": "storage",
            "baseName": "storage",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WarmCapacity.attributeTypeMap;
    }
    constructor() {
    }
}
